import { render, staticRenderFns } from "./EssayQuestion.vue?vue&type=template&id=a018a64e&scoped=true"
import script from "./EssayQuestion.vue?vue&type=script&lang=js"
export * from "./EssayQuestion.vue?vue&type=script&lang=js"
import style0 from "./EssayQuestion.vue?vue&type=style&index=0&id=a018a64e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a018a64e",
  null
  
)

export default component.exports